var Faq;
(function (Faq) {
    __once('.view-faq.view-id-faq', () => {
        const KEY_ENTER = 'Enter';
        const DROPDOWN_CLOSED_CLASS = 'closed';
        const ACCORDION_OPEN_CLASS = 'open';
        const $wrapper = document.querySelector('.faq-wrapper');
        const countElements = document.querySelector(".view-filters");
        const totalElements = document.querySelector(".total-elements .num");
        const dropdown = document.querySelector('.category-dropdown');
        const optionsList = dropdown === null || dropdown === void 0 ? void 0 : dropdown.querySelectorAll("li");
        const searchButton = $wrapper === null || $wrapper === void 0 ? void 0 : $wrapper.querySelector('.btn');
        const ctaListExpand = document.querySelectorAll(".faq-cta.expand");
        const ctaListCollapse = document.querySelectorAll(".faq-cta.collapse");
        const formSortSelect = document.querySelector('#edit-category.form-select');
        const formSubmitButton = document.querySelector('.submit-faq');
        if (totalElements) {
            totalElements.innerText = countElements === null || countElements === void 0 ? void 0 : countElements.getAttribute('data-view-results');
        }
        for (let i = 0; i < ctaListExpand.length; i++) {
            ctaListExpand[i].addEventListener("click", function () {
                document.querySelectorAll('.node--type-faq').forEach(function (n) {
                    n.classList.remove(ACCORDION_OPEN_CLASS);
                });
                ctaListExpand[i].closest('article').classList.add(ACCORDION_OPEN_CLASS);
            });
        }
        for (let i = 0; i < ctaListCollapse.length; i++) {
            ctaListCollapse[i].addEventListener("click", function () {
                ctaListCollapse[i].closest('article').classList.remove(ACCORDION_OPEN_CLASS);
            });
        }
        if ($wrapper) {
            const cat_array = [];
            document.querySelectorAll(".node--type-faq").forEach(function (n) {
                const cat = n.getAttribute('data-faq-category');
                if (cat && cat_array.indexOf(cat) === -1) {
                    cat_array.push(cat);
                }
            });
            searchButton.addEventListener('click', function () {
                const seletedCat = dropdown.querySelector(".selected").innerHTML;
                if (dropdown.querySelector(".selected").getAttribute('data-faq-category').toLowerCase() === 'all') {
                    document.querySelectorAll('.view-faq .views-row').forEach(function (n) {
                        n.classList.remove('hidden');
                    });
                }
                else {
                    document.querySelectorAll('.view-faq .views-row').forEach(function (n) {
                        n.classList.add('hidden');
                        if (n.querySelector('article').getAttribute('data-faq-category').toLowerCase() === seletedCat.toLowerCase()) {
                            n.classList.remove('hidden');
                        }
                    });
                }
            });
            dropdown.addEventListener('click', (e) => {
                dropdown.classList.toggle(DROPDOWN_CLOSED_CLASS);
                const dropdownItems = dropdown.querySelectorAll('.menu [tabindex]');
                dropdownItems.forEach(dropdownItem => {
                    dropdownItem.setAttribute('tabindex', dropdown.classList.contains(DROPDOWN_CLOSED_CLASS) ?
                        '-1' :
                        '0');
                });
            });
            dropdown.addEventListener('mouseleave', (e) => {
                if (!dropdown.classList.contains(DROPDOWN_CLOSED_CLASS)) {
                    dropdown.classList.add(DROPDOWN_CLOSED_CLASS);
                }
            });
            dropdown.addEventListener('keyup', (event) => {
                if (event.target == dropdown) {
                    if (event.key === KEY_ENTER) {
                        dropdown.click();
                    }
                }
            });
            function dropdownInit(target) {
                const selectedValueNode = target.querySelector('.selected');
                const dropdownOptions = target.querySelectorAll('.menu li');
                dropdownOptions.forEach(dropdownOption => {
                    dropdownOption.addEventListener('keyup', (event) => {
                        if (event.key === KEY_ENTER) {
                            dropdownOption.click();
                        }
                    });
                    dropdownOption.addEventListener('click', (event) => {
                        selectedValueNode.innerHTML = dropdownOption.innerHTML.toLowerCase();
                        target.classList.remove(DROPDOWN_CLOSED_CLASS);
                        formSortSelect.value = dropdownOption.dataset.sort;
                    });
                });
            }
            dropdownInit(dropdown);
        }
    });
})(Faq || (Faq = {}));
